export const receiptsEndpoints = {
  getReceiptSettings: { method: 'get', path: '/settings' },
  updateReceiptSettings: { method: 'post', path: '/settings/update' },
  createReceipt: { method: 'post', path: '/' },
  createReceiptUpload: { method: 'post', path: '/uploads' },
  getReceiptsByPurchaseOrderId: { method: 'get', path: '/by-purchase-order/{purchaseOrderId}' },
  getReceivingStatusByPurchaseOrderId: { method: 'get', path: '/by-purchase-order/{purchaseOrderId}/receiving-status' },
  getActiveReceiptUploadsByPurchaseOrderId: { method: 'get', path: '/by-purchase-order/{purchaseOrderId}/uploads' },
  cancelReceiptUpload: { method: 'post', path: '/uploads/{receiptUploadId}/cancel' },
  voidReceiptLineItem: { method: 'post', path: '/line-items/{receiptLineItemId}/void' },
} as const
